module.exports = __webpack_public_path__ + "static/media/defaultImage.59269ed2.png";